import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { logo } from "@/content/site";
import Footer from "@/components/apex/Footer";

export default function Privacy() {
  const { t, isRtl } = useLang();
  const Arrow = isRtl ? ArrowRight : ArrowLeft;

  return (
    <>
      <main className="mx-auto max-w-3xl px-5 py-24 sm:px-8 sm:py-32">
        <Link
          to="/"
          data-testid="privacy-back-home"
          className="inline-flex items-center gap-2 text-[14px] font-semibold text-[var(--yellow-dk)] transition-colors hover:text-[var(--text)]"
        >
          <Arrow className="h-4 w-4" strokeWidth={1.3} />
          {t.footer.backHome}
        </Link>

        <img
          src={logo.src}
          alt={isRtl ? logo.alt_ar : logo.alt_en}
          className="mt-12 h-8 w-auto brightness-0"
        />

        <h1 className="ap-display mt-10 text-[2rem] leading-tight text-[var(--text)] sm:text-[2.6rem]">
          {t.privacy.title}
        </h1>
        <p className="mt-5 text-[13.5px] text-[var(--muted)]">{t.privacy.updated}</p>

        <div className="mt-12 border-t border-[var(--line)]">
          {t.privacy.items.map((item, i) => (
            <section key={item.h} className="border-b border-[var(--line)] py-8">
              <div className="flex items-baseline gap-5">
                <span className="ap-mono grid h-8 w-8 shrink-0 place-items-center rounded-full bg-[var(--yellow)] text-[12px] font-bold text-[var(--charcoal)]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h2 className="ap-display text-lg text-[var(--text)]">{item.h}</h2>
                  <p className="mt-3 text-[13.5px] leading-[1.9] text-[var(--muted)]">{item.p}</p>
                </div>
              </div>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
}
